let base = require('@spark/resources/assets/js/auth/register-stripe');

Vue.component('invitation-registration', {
    mixins: [base],
    registerForm: new SparkForm({
        first_name: '',
        last_name: '',
        name: '',
        position: '',
        email: '',
        password: '',
        password_confirmation: '',
        address: '',
        address_line_2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        vat_id: '',
        terms: false,
        coupon: null,
        invitation: null,
        phone: '',
        account_holder_name: '',
        league: null,
        team_selection: null,
        new_team: null,
        market: null,
        venue_name: null,
        is_venue: this.isVenue,

        // settings
        settings: {
            newsletter_opt_in: false,
            heard_about_us: false,
            heard_about_us_text: null,
        },
    }),
});
